import Cookies from "js-cookie";
import config from "@/config";
import * as authPersistence from "@/modules/auth/persistence";
import * as api from "@/modules/auth/api";
import {
  SET_USERNAME,
  SET_REFRESH_TOKEN,
  SET_AUTH_TOKEN,
  SET_AUTH_TOKEN_EXPIRES,
  SET_USER_INFO,
  UPDATE_KID,
  RESET_AUTH_STATE
} from "./mutation-types";
import {
  SF_COOKIE_ACCESS_TOKEN,
  SF_COOKIE_AUTH_TOKEN_EXPIRES_IN,
  SF_COOKIE_REFRESH_TOKEN,
  SF_COOKIE_REMEMBER_ME,
  SF_COOKIE_USERNAME
} from "@/modules/auth/persistence/constants";
import { defaultAuthState } from "./index";
export default {
  async me({ commit }) {
    console.log(`[Action] api/me`);
    const oRes = await api.me();
    commit(SET_USER_INFO, oRes);
  },
  async getKids({ commit }) {
    console.log(`[Action] getKids`);
    const oRes = await api.getKids();
    oRes.forEach(kid => {
      let oKid = kid.attributes;
      oKid.id = kid.id;
      commit(UPDATE_KID, oKid);
    });
  },
  async createKid({ commit }, oParams) {
    console.log(`[Action] createKid`);
    const oRes = await api.createKid(oParams);
    if (oRes.id && oRes.attributes) {
      let oKid = oRes.attributes;
      oKid.id = oRes.id;
      commit(UPDATE_KID, oKid);
      return oKid;
    }
  },
  async updateKidInfo({ commit }, { kidId, oParams }) {
    console.log(`[Action] update kid`);
    const oRes = await api.updateKid(kidId, oParams);
    if (oRes.attributes && oRes.id) {
      let oKid = oRes.attributes;
      oKid.id = oRes.id;
      commit(UPDATE_KID, oKid);
      return oKid;
    }
  },
  login: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      api.login(params.username, params.password).then(
        function(authInfo) {
          if (
            authInfo.access_token &&
            authInfo.refresh_token &&
            authInfo.expires_in
          ) {
            authPersistence.persistAuthState(
              params.username,
              authInfo.access_token,
              authInfo.refresh_token,
              authInfo.expires_in
            );
            commit(SET_USERNAME, params.username);
            commit(SET_AUTH_TOKEN, authInfo.access_token);
            commit(SET_REFRESH_TOKEN, authInfo.refresh_token);
            commit(SET_AUTH_TOKEN_EXPIRES, authInfo.expires_in);
            resolve(authInfo);
          } else {
            reject(new Error("Auth response missing auth credentials"));
          }
        },
        function(err) {
          reject(err);
        }
      );
    });
  },
  logout: ({ dispatch }) => {
    return new Promise(resolve => {
      const flushAuth = function() {
        authPersistence.flushAuthState();
        dispatch("resetAuthState");
        dispatch("resetUiState");
        dispatch("resetAppState");
        dispatch("resetCartState");
        dispatch("resetOrderState");
        dispatch("resetInventoryState");
        resolve();
      };
      flushAuth();
    });
  },
  setupUserAuthFromCookie: ({ commit }, bPersistAuth) => {
    // this function is called when the app launches BEFORE the router is loaded
    const cookieSettings = config.get("COOKIE_SETTINGS");
    const username = Cookies.get(SF_COOKIE_USERNAME, cookieSettings);
    const accessToken = Cookies.get(SF_COOKIE_ACCESS_TOKEN, cookieSettings);
    const refreshToken = Cookies.get(SF_COOKIE_REFRESH_TOKEN, cookieSettings);
    const authTokenExpiresIn = Cookies.get(
      SF_COOKIE_AUTH_TOKEN_EXPIRES_IN,
      cookieSettings
    );
    const rememberMe = Cookies.get(SF_COOKIE_REMEMBER_ME, cookieSettings);
    if (username && accessToken && refreshToken && authTokenExpiresIn) {
      if (rememberMe === "true" || bPersistAuth === true) {
        // the user selected 'remember me', we'll add their creds to the store so login is skipped
        // if persistAuth is passed, we'll also persist
        if (rememberMe === "true") {
          console.log(
            "[Auth] Remember me selected. Adding user info from cookie"
          );
        }
        if (bPersistAuth === true) {
          console.log("[Auth] Force persist. Adding user info from cookie");
        }
        commit(SET_USERNAME, username);
        commit(SET_AUTH_TOKEN, accessToken);
        commit(SET_REFRESH_TOKEN, refreshToken);
        commit(SET_AUTH_TOKEN_EXPIRES, authTokenExpiresIn);
      } else {
        // 'remember me' wasn't selected. We'll nuke the cookie so they have to login again
        console.log("[Auth] Remember me not selected. Flushing user info");
        authPersistence.flushAuthState();
      }
    } else {
      console.log("[Auth] No user info found in cookie");
    }
  },
  resetAuthState: ({ commit }) => {
    commit(RESET_AUTH_STATE, defaultAuthState());
  }
};
